(function () {
  'use strict';

  var SCREENS = ['hero', 'intent', 'metal', 'types', 'style', 'occasion', 'tier', 'notes', 'result'];
  var QUESTION_SCREENS = ['intent', 'metal', 'types', 'style', 'occasion', 'tier', 'notes'];

  var TIER_META = {
    bronze: {
      label: 'Signature Membership',
      shortLabel: 'Signature',
      contents: ['2x Fine Sterling Silver pieces', 'Stylist note included', 'Gift-ready packaging'],
      price: '£99'
    },
    silver: {
      label: 'Prestige Membership',
      shortLabel: 'Prestige',
      popular: true,
      contents: ['1x 9ct Gold piece', '2x Sterling Silver pieces', 'Most gifted tier'],
      price: '£199'
    },
    gold: {
      label: 'Reserve Membership',
      shortLabel: 'Reserve',
      contents: ['1x 18ct Gold piece', '1x 9ct Gold piece', '1x Sterling Silver piece'],
      price: '£299'
    },
    platinum: {
      label: 'Privé Membership',
      shortLabel: 'Privé',
      contents: ['1x 18ct Gold statement piece', '2x 9ct Gold pieces', '1x Sterling Silver piece'],
      price: '£399'
    }
  };

  var FREQUENCY_LABELS = {
    monthly: 'Monthly',
    bimonthly: 'Every 2 months',
    quarterly: 'Quarterly'
  };

  var STYLE_ICON_MAP = {
    'Delicate & minimal': 'minimal',
    'Statement & bold': 'bold',
    'Natural stone & organic': 'stone',
    'Layering & stacking': 'layering',
    'Classic & timeless': 'classic',
    'Modern & sculptural': 'modern',
    'Pearls & soft romance': 'pearls',
    'Personalised & charms': 'charms',
    'Celestial & spiritual': 'celestial',
    'Pave & diamond-set': 'pave'
  };

  var METAL_SYMBOL_MAP = {
    'Sterling Silver': 'Ag',
    '9ct Gold': '9k',
    '18ct Gold': '18k'
  };

  var STORAGE_KEY = 'hk_quiz_funnel_state';

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var productData = {};
    try {
      var dataEl = document.getElementById('QuizFunnelProducts-' + root.dataset.sectionId);
      if (dataEl) productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Quiz Funnel: failed to parse product data', e);
    }

    var state = {
      screen: 'hero',
      intent: '',
      metal: '',
      types: [],
      style: [],
      occasion: '',
      tier: '',
      frequency: '',
      stylistNote: ''
    };

    var screens = {};
    SCREENS.forEach(function (name) {
      screens[name] = root.querySelector('[data-screen="' + name + '"]');
    });

    var progressWrap = root.querySelector('.quiz-funnel__progress-wrap');
    var progressFill = root.querySelector('.quiz-funnel__progress-fill');
    var progressStep = root.querySelector('[data-progress-step]');
    var progressBar = root.querySelector('.quiz-funnel__progress-bar');

    function saveState() {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (e) { /* ignore */ }
    }

    function loadState() {
      try {
        var saved = sessionStorage.getItem(STORAGE_KEY);
        if (!saved) return;
        var parsed = JSON.parse(saved);
        Object.keys(state).forEach(function (key) {
          if (parsed[key] !== undefined) state[key] = parsed[key];
        });
        restoreInputs();
      } catch (e) { /* ignore */ }
    }

    function restoreInputs() {
      setRadio('qf-intent', state.intent);
      setRadio('qf-metal', state.metal);
      setRadio('qf-occasion', state.occasion);
      setRadio('qf-frequency', state.frequency);
      setRadio('qf-tier', state.tier);
      setMulti('qf-types', state.types);
      setMulti('qf-style', state.style);
      var notesField = root.querySelector('[name="qf-stylist-note"]');
      if (notesField) notesField.value = state.stylistNote || '';
      updateFrequencyAvailability();
    }

    function setRadio(name, value) {
      if (!value) return;
      root.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        input.checked = input.value === value;
      });
    }

    function setMulti(name, values) {
      if (!values || !values.length) return;
      root.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        input.checked = values.indexOf(input.value) !== -1;
      });
    }

    function updateSelectionCounts() {
      updateSelectionCount('qf-types', 'types', 'piece');
      updateSelectionCount('qf-style', 'style', 'style');
    }

    function updateSelectionCount(inputName, key, noun) {
      var el = root.querySelector('[data-selection-count="' + key + '"]');
      if (!el) return;
      var count = root.querySelectorAll('input[name="' + inputName + '"]:checked').length;
      if (count === 0) {
        el.textContent = '';
      } else if (count === 1) {
        el.textContent = '1 ' + noun + ' selected';
      } else {
        el.textContent = count + ' ' + noun + 's selected';
      }
    }

    function screenIsValid(screen) {
      switch (screen) {
        case 'intent':
        case 'metal':
        case 'occasion':
          return !!root.querySelector('input[name="qf-' + screen + '"]:checked');
        case 'types':
          return root.querySelectorAll('input[name="qf-types"]:checked').length > 0;
        case 'style':
          return root.querySelectorAll('input[name="qf-style"]:checked').length > 0;
        case 'tier':
          return !!root.querySelector('input[name="qf-frequency"]:checked') &&
            !!root.querySelector('input[name="qf-tier"]:checked');
        default:
          return true;
      }
    }

    function updateContinueButtons() {
      root.querySelectorAll('[data-action="next"]').forEach(function (btn) {
        var screenEl = btn.closest('[data-screen]');
        if (!screenEl) return;
        var screenName = screenEl.dataset.screen;
        var valid = screenIsValid(screenName);
        btn.classList.toggle('is-disabled', !valid);
        btn.setAttribute('aria-disabled', valid ? 'false' : 'true');
      });
    }

    function updateBackButtons() {
      root.querySelectorAll('[data-action="back"]').forEach(function (btn) {
        var screenEl = btn.closest('[data-screen]');
        var hide = screenEl && screenEl.dataset.screen === 'intent';
        btn.hidden = hide;
      });
    }

    var errorEl = root.querySelector('.quiz-funnel__error');

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }

    function getQuestionIndex() {
      return QUESTION_SCREENS.indexOf(state.screen);
    }

    function updateProgress() {
      var idx = getQuestionIndex();
      if (idx < 0 || state.screen === 'hero' || state.screen === 'result') {
        if (progressWrap) progressWrap.hidden = state.screen === 'hero' || state.screen === 'result';
        return;
      }
      if (progressWrap) progressWrap.hidden = false;
      var pct = ((idx + 1) / 7) * 100;
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressStep) progressStep.textContent = 'Step ' + (idx + 1) + ' of 7';
      if (progressBar) {
        progressBar.setAttribute('aria-valuenow', String(Math.round(pct)));
        progressBar.setAttribute('aria-valuetext', 'Step ' + (idx + 1) + ' of 7');
      }
    }

    function goTo(screen) {
      clearError();
      state.screen = screen;
      SCREENS.forEach(function (name) {
        if (screens[name]) {
          screens[name].classList.toggle('is-active', name === screen);
        }
      });
      updateProgress();
      updateContinueButtons();
      updateBackButtons();
      updateSelectionCounts();
      saveState();
      if (screen === 'result') renderResult();
      if (screen === 'tier') updateFrequencyAvailability();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function readSingle(name, prop) {
      var checked = root.querySelector('input[name="' + name + '"]:checked');
      state[prop] = checked ? checked.value : '';
    }

    function readMulti(name, prop) {
      state[prop] = Array.prototype.map.call(
        root.querySelectorAll('input[name="' + name + '"]:checked'),
        function (el) { return el.value; }
      );
    }

    function validateCurrent() {
      switch (state.screen) {
        case 'intent':
        case 'metal':
        case 'occasion':
          readSingle(state.screen === 'intent' ? 'qf-intent' : state.screen === 'metal' ? 'qf-metal' : 'qf-occasion',
            state.screen === 'intent' ? 'intent' : state.screen === 'metal' ? 'metal' : 'occasion');
          if (!state[state.screen === 'intent' ? 'intent' : state.screen === 'metal' ? 'metal' : 'occasion']) {
            showError('Please select an option to continue.');
            return false;
          }
          break;
        case 'types':
          readMulti('qf-types', 'types');
          if (state.types.length === 0) {
            showError('Please select at least one option.');
            return false;
          }
          break;
        case 'style':
          readMulti('qf-style', 'style');
          if (state.style.length === 0) {
            showError('Please select at least one style.');
            return false;
          }
          break;
        case 'tier':
          readSingle('qf-frequency', 'frequency');
          readSingle('qf-tier', 'tier');
          if (!state.frequency) {
            showError('Please select a delivery frequency.');
            return false;
          }
          if (!state.tier) {
            showError('Please select a subscription tier.');
            return false;
          }
          break;
        case 'notes':
          var notesField = root.querySelector('[name="qf-stylist-note"]');
          state.stylistNote = notesField ? notesField.value.trim() : '';
          break;
      }
      return true;
    }

    function nextScreen() {
      if (!validateCurrent()) return;
      var idx = SCREENS.indexOf(state.screen);
      if (idx < SCREENS.length - 1) goTo(SCREENS[idx + 1]);
    }

    function prevScreen() {
      var idx = SCREENS.indexOf(state.screen);
      if (idx > 0) goTo(SCREENS[idx - 1]);
    }

    function isGiftIntent() {
      return state.intent === 'gift' || state.intent === 'occasion';
    }

    function renderResult() {
      var meta = TIER_META[state.tier] || {};
      var freqLabel = FREQUENCY_LABELS[state.frequency] || state.frequency;

      var headline = root.querySelector('[data-result-headline]');
      var subhead = root.querySelector('[data-result-subhead]');
      if (headline) {
        headline.textContent = isGiftIntent()
          ? 'Your curated gift box is ready'
          : 'Your curated box is ready';
      }
      if (subhead) {
        subhead.textContent = isGiftIntent()
          ? 'Based on your gift profile, we\'ve prepared a personal Harper Kendall recommendation.'
          : 'Based on your style profile, we\'ve prepared your personal Harper Kendall recommendation.';
      }

      setText(root, '[data-result-tier]', meta.label || state.tier);
      setText(root, '[data-result-frequency]', freqLabel);
      setText(root, '[data-result-metal]', state.metal);
      setText(root, '[data-result-style]', state.style.join(', '));

      setResultIcon('[data-result-tier-icon]', state.tier ? 'tier-' + state.tier : '');
      setResultIcon('[data-result-frequency-icon]', state.frequency || '');
      setMetalResultIcon('[data-result-metal-icon]', state.metal);
      setStyleResultIcons('[data-result-style-icon]', state.style);

      var planTitle = root.querySelector('[data-result-plan-title]');
      var planPrice = root.querySelector('[data-result-plan-price]');
      var planList = root.querySelector('[data-result-plan-list]');

      if (planTitle) planTitle.textContent = (meta.shortLabel || meta.label || '') + ' Concierge';
      if (planPrice) planPrice.textContent = (meta.price || '') + ' / ' + freqLabel.toLowerCase() + '. Cancel anytime.';

      if (planList && meta.contents) {
        planList.innerHTML = meta.contents.map(function (item) {
          return '<li>' + escapeHtml(item) + '</li>';
        }).join('');
      }
    }

    function setText(container, selector, text) {
      var el = container.querySelector(selector);
      if (el) el.textContent = text || '-';
    }

    function getIconMarkup(iconName) {
      if (!iconName) return '';
      var iconLibrary = root.querySelector('[data-quiz-icon-library]');
      if (!iconLibrary) return '';
      var src = iconLibrary.querySelector('[data-icon="' + iconName + '"]');
      return src ? src.innerHTML : '';
    }

    function setResultIcon(selector, iconName) {
      var el = root.querySelector(selector);
      if (el) el.innerHTML = getIconMarkup(iconName);
    }

    function setMetalResultIcon(selector, metal) {
      var el = root.querySelector(selector);
      if (!el) return;
      var symbol = METAL_SYMBOL_MAP[metal];
      el.innerHTML = symbol
        ? '<span class="quiz-funnel__metal-symbol">' + escapeHtml(symbol) + '</span>'
        : '';
    }

    function setStyleResultIcons(selector, styles) {
      var el = root.querySelector(selector);
      if (!el) return;
      var icons = (styles || []).slice(0, 3).map(function (style) {
        return STYLE_ICON_MAP[style];
      }).filter(Boolean);
      el.innerHTML = icons.map(function (iconName) {
        return getIconMarkup(iconName);
      }).join('');
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function updateFrequencyAvailability() {
      var freqSection = root.querySelector('.quiz-funnel__frequency');
      var hintEl = root.querySelector('[data-frequency-hint]');
      var noTier = !state.tier;

      if (freqSection) freqSection.classList.toggle('is-locked', noTier);

      if (noTier || !productData.tiers) {
        root.querySelectorAll('input[name="qf-frequency"]').forEach(function (input) {
          var wrap = input.closest('.quiz-funnel__option');
          input.disabled = true;
          input.checked = false;
          if (wrap) {
            wrap.classList.remove('is-disabled', 'is-unavailable');
          }
        });
        if (hintEl) {
          hintEl.textContent = 'Choose a subscription tier first, then select your delivery frequency.';
          hintEl.hidden = false;
        }
        return;
      }

      var tierData = productData.tiers[state.tier];
      var sellingPlans = tierData && tierData.sellingPlans;
      var hasPlans = sellingPlans && Object.keys(sellingPlans).length > 0;

      if (!hasPlans) {
        root.querySelectorAll('input[name="qf-frequency"]').forEach(function (input) {
          var wrap = input.closest('.quiz-funnel__option');
          input.disabled = false;
          if (wrap) wrap.classList.remove('is-disabled', 'is-unavailable');
        });
        if (hintEl) hintEl.hidden = true;
        return;
      }

      if (state.frequency && !tierData.sellingPlans[state.frequency]) {
        state.frequency = '';
      }

      var unavailableCount = 0;

      root.querySelectorAll('input[name="qf-frequency"]').forEach(function (input) {
        var wrap = input.closest('.quiz-funnel__option');
        var available = !!tierData.sellingPlans[input.value];
        if (wrap) {
          wrap.classList.toggle('is-disabled', !available);
          wrap.classList.toggle('is-unavailable', !available);
        }
        input.disabled = !available;
        if (!available) {
          unavailableCount += 1;
          if (input.checked) input.checked = false;
        }
      });

      if (!state.frequency) {
        root.querySelectorAll('input[name="qf-frequency"]').forEach(function (input) {
          if (state.frequency) return;
          if (!input.disabled) {
            input.checked = true;
            state.frequency = input.value;
          }
        });
      } else {
        setRadio('qf-frequency', state.frequency);
      }

      if (hintEl) {
        if (unavailableCount === 2) {
          hintEl.textContent = 'Every 2 months and Quarterly delivery are coming soon. Monthly is available now.';
          hintEl.hidden = false;
        } else if (unavailableCount > 0) {
          hintEl.textContent = 'Some delivery options are not yet available for this tier.';
          hintEl.hidden = false;
        } else {
          hintEl.hidden = true;
        }
      }
    }

    async function subscribe() {
      clearError();
      if (!state.tier || !state.frequency) {
        showError('Please complete the quiz to subscribe.');
        return;
      }

      var tierData = productData.tiers && productData.tiers[state.tier];
      if (!tierData) {
        showError('Subscription product not found. Please contact us.');
        return;
      }

      var sellingPlanId = tierData.sellingPlans && tierData.sellingPlans[state.frequency];
      if (!sellingPlanId) {
        showError('This delivery frequency is not yet available for the selected tier. Please choose Monthly or contact us.');
        return;
      }

      var btn = root.querySelector('[data-action="subscribe"]');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('quiz-funnel__btn--loading');
        btn.setAttribute('aria-busy', 'true');
      }

      var properties = {
        'Intent': state.intent,
        'Metal Preference': state.metal,
        'Jewellery Types': state.types.join(', '),
        'Style': state.style.join(', '),
        'Occasion': state.occasion,
        'Recommended Tier': TIER_META[state.tier] ? TIER_META[state.tier].label : state.tier,
        'Frequency': FREQUENCY_LABELS[state.frequency] || state.frequency,
        'Stylist Note': state.stylistNote || ''
      };

      var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      try {
        var res = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: tierData.variantId,
              quantity: 1,
              selling_plan: sellingPlanId,
              properties: properties
            }]
          })
        });

        var responseJson = await res.json();

        if (!res.ok) {
          throw new Error(responseJson.description || responseJson.message || 'Could not add subscription to cart.');
        }

        window.location.assign(rootPath + 'checkout');
      } catch (err) {
        showError(err.message || 'Something went wrong. Please try again.');
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('quiz-funnel__btn--loading');
          btn.setAttribute('aria-busy', 'false');
        }
      }
    }

    root.addEventListener('click', function (e) {
      var action = e.target.closest('[data-action]');
      if (!action) return;
      var act = action.dataset.action;

      if (act === 'start') goTo('intent');
      else if (act === 'next') {
        if (action.classList.contains('is-disabled')) return;
        nextScreen();
      }
      else if (act === 'back') prevScreen();
      else if (act === 'skip-notes') {
        state.stylistNote = '';
        goTo('result');
      }
      else if (act === 'subscribe') subscribe();
    });

    root.addEventListener('change', function (e) {
      if (e.target.name === 'qf-tier') {
        readSingle('qf-tier', 'tier');
        updateFrequencyAvailability();
      }
      if (e.target.name === 'qf-frequency') {
        if (e.target.disabled) {
          e.target.checked = false;
          return;
        }
        readSingle('qf-frequency', 'frequency');
      }
      if (e.target.name === 'qf-intent') readSingle('qf-intent', 'intent');
      if (e.target.name === 'qf-metal') readSingle('qf-metal', 'metal');
      if (e.target.name === 'qf-occasion') readSingle('qf-occasion', 'occasion');
      if (e.target.name === 'qf-types') readMulti('qf-types', 'types');
      if (e.target.name === 'qf-style') readMulti('qf-style', 'style');
      updateContinueButtons();
      updateSelectionCounts();
      saveState();
    });

    root.querySelectorAll('input[name="qf-types"], input[name="qf-style"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var name = input.name;
        if (name === 'qf-types' && input.value === 'All of the above' && input.checked) {
          root.querySelectorAll('input[name="qf-types"]').forEach(function (el) {
            if (el.value !== 'All of the above' && el.value !== 'No preference') el.checked = false;
          });
        }
        if (name === 'qf-types' && (input.value === 'No preference') && input.checked) {
          root.querySelectorAll('input[name="qf-types"]').forEach(function (el) {
            if (el !== input) el.checked = false;
          });
        }
        if (name === 'qf-style') {
          /* no exclusivity needed */
        }
      });
    });

    loadState();
    updateFrequencyAvailability();
    updateContinueButtons();
    updateBackButtons();
    updateSelectionCounts();
    goTo(state.screen && SCREENS.indexOf(state.screen) > 0 ? state.screen : 'hero');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quiz-funnel').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.quiz-funnel');
    if (root) init(root);
  });
})();
